import { HttpClient } from 'aurelia-http-client';

export class TestimonialCaptureAPI {

    constructor(capture_type) {
        this.http = new HttpClient().configure(x => {
            x.withHeader('Content-Type', 'application/json');
        });

        this.capture_type = capture_type;
        switch(capture_type) {
            case 0:
                this.urlbase = "api/testimonialRequest/";
            break;
            case 1:
                this.urlbase = "api/testimonialLinkSubmission/";
            break;
            case 2:
                this.urlbase = "api/brandVideo/";
            break;
            case 3:
                this.urlbase = "api/videoEmail/";
            break;
            case 4:
                this.urlbase = "api/caseStudy/";
            break;
            case 5:
                this.urlbase = "api/videoMessage/";
            break;
        }


    }

   getVerbiage(key, successCallback, errorCallback) {
       console.log('$$$$$$$$$');
        this.http.get(this.urlbase + 'getVerbiage/' + key)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);
                    console.log(JSON.stringify(json));
                    successCallback(json);
                     if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    getByCaptureKey(key, successCallback, errorCallback,video_id=null) {

        this.http.get(this.urlbase + 'getByCaptureKey/' + key +(video_id?("?video_id="+video_id):""))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);
                    switch(this.capture_type) {
                        case 0:
                            if(json.hasOwnProperty("instructions") && json.hasOwnProperty("org_name") && json.hasOwnProperty("mlink_return_url"))
                                successCallback(json.org_name, null, json.mlink_return_url, json.chrome_min_ver || null, json.instructions,json.topic);
                            break;
                        case 1:
                            if(json.hasOwnProperty("org_name") && json.hasOwnProperty("website") && json.hasOwnProperty("mlink_return_url"))
                                successCallback(json.org_name, json.website, json.mlink_return_url, json.chrome_min_ver || null, json.topic);
                            break;
                        case 2:
                            successCallback(null, null, null, json.chrome_min_ver || null, json.topic);
                            break;
                        case 3:
                            successCallback(null, null, null, json.chrome_min_ver || null, json.topic);
                            break;
                        case 4:
                            successCallback(json.org_name || null, null, json.mlink_return_url || null, json.chrome_min_ver || null, json.nextQuestion || null, json.questionNum || null, json.topic);
                            break;
                        case 5:
                            successCallback(null, null, null, json.chrome_min_ver || null,json.topic);
                            break;
                    }


                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    createVideo(data, successCallback, errorCallback) {

        this.http.post(this.urlbase + 'create', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video_id"))
                        successCallback(json.video_id);


                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    completeCapture(data, successCallback, errorCallback) {

        this.http.post(this.urlbase + 'completeCapture', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    if(data.response) {
                        var json = JSON.parse(data.response);

                        if(json.hasOwnProperty("done"))
                            successCallback(json.done);

                    }
                    else
                        successCallback();
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    remindme(data, successCallback, errorCallback) {


        this.http.post(this.urlbase + 'remindme', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    if(data.response) {
                        var json = JSON.parse(data.response);

                        if(json.hasOwnProperty("error"))
                            errorCallback(json.error);
                    }
                    else
                        successCallback();

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    decline(data, successCallback, errorCallback) {


        this.http.post(this.urlbase + 'decline', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {

                    if(data.response) {
                        var json = JSON.parse(data.response);

                        if(json.hasOwnProperty("error"))
                            errorCallback(json.error);
                    }
                    else
                        successCallback();

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

}
